import styled, { StyledProps } from 'styled-components'

type StatusIconProps = StyledProps<{ status?: 'active' | 'inactive' | 'deleted' }>

export const StatusIcon = styled.span<StatusIconProps>`
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  margin-left: 2px;
  flex-shrink: 0;
  display: inline-block;
  ${({ theme, status }: StatusIconProps) => {
    switch (status) {
      case 'active':
        return {
          background: theme.color.accentApproving,
        }
      case 'deleted':
        return {
          background: theme.color.accentDestructive,
        }
      case 'inactive':
        return {
          background: theme.color.accentNotify,
        }
      default:
        return {
          border: `1px solid ${theme.color.onSurfaceMidEmphasys}`,
        }
    }
  }};
`
